module.exports = "mat-form-field {\n  display: block;\n  width: 100%;\n}\n.button-container {\n  margin-top: 25px;\n}\n.button-container button {\n  margin-right: 5px;\n}\n.error-text {\n  color: red;\n}\n.slider {\n  margin-bottom: 25px;\n}\nmat-form-field.disabled {\n  pointer-events: none;\n  opacity: 0.5;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/project/dialogs/velocity/velocity.component.less
// module id = ./src/app/projects/project/dialogs/velocity/velocity.component.less
// module chunks = main